<script>
    import { initTranslatableValue } from "./initTranslatableValues";
    import { initValue } from "./initValues";
    import { createEventDispatcher } from "svelte";
    import TranslationSelect from "../TranslationSelect.svelte";
    import { isTranslationNeeded } from "./isTranslationNeeded";
    import RequiredErrorLabel from "./shared/RequiredErrorLabel.svelte";

    export let value;
    export let label;
    export let required;
    export let translatable;

    const dispatch = createEventDispatcher();

    $: editLocale = "de";
    $: internalValue = translatable
        ? initTranslatableValue(value)
        : initValue(value);

    $: translationNeeded = required && isTranslationNeeded(internalValue);

    function dispatchValueChange(val) {
        if (translatable) {
            internalValue[editLocale] = val.target.value;
        } else {
            internalValue = val.target.value;
        }
        dispatch("change", internalValue);
    }
</script>

<div>
    <div class="section-title-row">
        <label class="form-field-label">{label}</label>
        {#if translatable}
            <TranslationSelect {translationNeeded} bind:editLocale />
        {/if}
    </div>
    <input
        class="input-style"
        type="text"
        value={translatable ? internalValue[editLocale] : internalValue}
        on:input={dispatchValueChange}
    />
    {#if required && (!internalValue || (!internalValue.de && translatable))}
        <RequiredErrorLabel />
    {/if}
</div>

<style>
    .input-style {
        border: 1px solid var(--black-100);
        padding: 24px 20px;
        background: transparent;
        width: 526px;
    }

    .form-field-label {
        font-weight: bold;
    }

    .section-title-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
</style>
